import React, { useEffect, useRef, useState } from "react";

import { Icon } from "../icon/Icon";
import "./DropdownMenu.scss";

interface DropdownMenuProps {
  options: number[];
  selectedOption: number | undefined;
  onSelectOption: (option: number) => void;
  disableCurrentYear?: boolean;
  disableFirstYear?: boolean;
}

const DropdownMenu = ({
  options,
  selectedOption,
  onSelectOption,
  disableCurrentYear = false,
  disableFirstYear = false,
}: DropdownMenuProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option: number) => {
    onSelectOption(option);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button className="dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
        {selectedOption}
        <Icon name="chevron" rotate={90} />
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => handleOptionClick(option)}
              className={`${selectedOption === option ? "selected-li" : ""}`}
              style={{
                pointerEvents:
                  (disableCurrentYear && option === options[0]) ||
                  (disableFirstYear && option === options[options.length - 1])
                    ? "none"
                    : "auto",
                opacity:
                  (disableCurrentYear && option === options[0]) ||
                  (disableFirstYear && option === options[options.length - 1])
                    ? 0.5
                    : 1,
              }}
            >
              {option}
              {selectedOption === option && (
                <Icon name="checkmark" className="checkmark-icon" />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownMenu;
